import {
  GET_DELIVERY_ORDER, GET_INVENTORY,
  GET_PACKAGE_REQUEST,
  GET_PICKUP_REQUESTS,
  GET_SENDER_LIST,
  GetRequest,
  GetResultObject
} from "../../../utils/API";

const TYPES = {
  REQUEST_MERCHANT: "REQUEST_MERCHANT",
  REQUEST_MERCHANT_SUCCESS: "REQUEST_MERCHANT_SUCCESS",
  REQUEST_MERCHANT_FAILED: "REQUEST_MERCHANT_FAILED",
  UPDATE_MERCHANT_LIST: "UPDATE_MERCHANT_LIST",

  REQUEST_PICKUP_REQUEST: "REQUEST_PICKUP_REQUEST",
  REQUEST_PICKUP_REQUEST_SUCCESS: "REQUEST_PICKUP_REQUEST_SUCCESS",
  REQUEST_PICKUP_REQUEST_FAILED: "REQUEST_PICKUP_REQUEST_FAILED",
  UPDATE_PICKUP_REQUEST_LIST: "UPDATE_PICKUP_REQUEST_LIST",

  REQUEST_PACKAGE_REQUEST: "REQUEST_PACKAGE_REQUEST",
  REQUEST_PACKAGE_REQUEST_SUCCESS: "REQUEST_PACKAGE_REQUEST_SUCCESS",
  REQUEST_PACKAGE_REQUEST_FAILED: "REQUEST_PACKAGE_REQUEST_FAILED",

  REQUEST_ORDER_PACKAGE_REQUEST: "REQUEST_ORDER_PACKAGE_REQUEST",
  REQUEST_ORDER_PACKAGE_REQUEST_SUCCESS: "REQUEST_ORDER_PACKAGE_REQUEST_SUCCESS",
  REQUEST_ORDER_PACKAGE_REQUEST_FAILED: "REQUEST_ORDER_PACKAGE_REQUEST_FAILED",
  UPDATE_ORDER_PACKAGE_LIST: "UPDATE_ORDER_PACKAGE_LIST",

  REQUEST_INVENTORY: "REQUEST_INVENTORY",
  REQUEST_INVENTORY_SUCCESS: "REQUEST_INVENTORY_SUCCESS",
  REQUEST_INVENTORY_FAILED: "REQUEST_INVENTORY_FAILED",
  UPDATE_INVENTORY_LIST: "UPDATE_INVENTORY_LIST",
};


const getMerchant = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_MERCHANT,
      payload: {},
    });

    GetRequest(GET_SENDER_LIST, params).then(result=> {
      GetResultObject(result, 'data.content', 200, (datas, page) => {
        dispatch({
          type: TYPES.REQUEST_MERCHANT_SUCCESS,
          payload: {data: datas, ...page},
        });
      })
    })
  }
}

const getPickupRequests = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_PICKUP_REQUEST,
      payload: {},
    });

    GetRequest(GET_PICKUP_REQUESTS, params).then(result=> {
      GetResultObject(result, 'data.content', 200, (datas, page) => {
        dispatch({
          type: TYPES.REQUEST_PICKUP_REQUEST_SUCCESS,
          payload: {data: datas, ...page},
        });
      })
    })
  }
}

const getPackageRequests = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_PACKAGE_REQUEST,
      payload: {},
    });

    GetRequest(GET_PACKAGE_REQUEST, params).then(result=> {
      GetResultObject(result, 'data.content', 200, (datas, page) => {
        dispatch({
          type: TYPES.REQUEST_PACKAGE_REQUEST_SUCCESS,
          payload: {data: datas, ...page},
        });
      })
    })
  }
}


const getOrderPackages = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_ORDER_PACKAGE_REQUEST,
      payload: {},
    });

    GetRequest(GET_DELIVERY_ORDER, params).then(result=> {
      GetResultObject(result, 'data.content', 200, (datas, page) => {
        dispatch({
          type: TYPES.REQUEST_ORDER_PACKAGE_REQUEST_SUCCESS,
          payload: {data: datas, ...page},
        });
      })
    })
  }
}

const getInventories = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_INVENTORY,
      payload: {},
    });

    GetRequest(GET_INVENTORY, params).then(result=> {
      GetResultObject(result, 'data.content', 200, (datas, page) => {
        dispatch({
          type: TYPES.REQUEST_INVENTORY_SUCCESS,
          payload: {data: datas, ...page},
        });
      })
    })
  }
}

const updateInvoiceList = (payload) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.UPDATE_INVOICE_LIST,
      payload: payload,
    });
  }
}

export default {
  getMerchant,
  getPickupRequests,
  getPackageRequests,
  getOrderPackages,
  getInventories,
  TYPES,
};
